import i18n from '@/locales'

export default {
  system: {
    options: [
      { id: 'dashboard-system-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-system-default': [{
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 0,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_cpu',
        name: i18n.t('dashboard.container_server_count'),
        regionAccountType: 'region',
        usage_key: 'all.containers',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 20,
        y: 0,
      },
      params: {
        name: i18n.t('dashboard.running_containers_count'),
        regionAccountType: 'region',
        usage_key: 'all.running_containers',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 40,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_tenant',
        name: i18n.t('usage.hosts'),
        regionAccountType: 'region',
        usage_key: 'hosts',
      },
    }, {
      layout: {
        component: 'UserInfo',
        h: 6,
        w: 20,
        x: 60,
        y: 0,
      },
      params: {
        name: i18n.t('dashboard.userinfo'),
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 0,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_ram',
        name: i18n.t('dashboard.container_server_cpu_num'),
        regionAccountType: 'region',
        usage_key: 'all.containers.cpu',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 20,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_cpu',
        name: i18n.t('dashboard.running_containers_cpu_num'),
        regionAccountType: 'region',
        usage_key: 'all.running_containers.cpu',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 40,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_baremetal',
        name: i18n.t('dashboard.containers_memory'),
        regionAccountType: 'region',
        usage_key: 'all.containers.memory',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 60,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_ram',
        name: i18n.t('dashboard.running_containers_memory_num'),
        regionAccountType: 'region',
        usage_key: 'all.running_containers.memory',
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 0,
        y: 12,
      },
      params: {
        all_usage_key: 'all.containers',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.container_server_running_rate'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.all.no_running_servers'),
        usage_key: 'all.running_containers',
        usage_label: i18n.t('dashboard.all.running_servers'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 20,
        y: 12,
      },
      params: {
        all_usage_key: 'all.disks.count',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_147'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.not_mounted'),
        usage_key: 'all.disks.mounted.count',
        usage_label: i18n.t('dashboard.mounted'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 40,
        y: 12,
      },
      params: {
        all_usage_key: 'all.ports',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_152'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.text_34'),
        usage_key: 'all.nics',
        usage_label: i18n.t('dashboard.text_33'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 60,
        y: 12,
      },
      params: {
        all_usage_key: 'all.eip.floating_ip',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_156'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.text_34'),
        usage_key: 'all.eip.floating_ip.used',
        usage_label: i18n.t('dashboard.text_33'),
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 0,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.text_126'),
        order: 'TOP',
        resType: 'server',
        time: 108000,
        usage: 'usage_active,vm_cpu',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 20,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.memory_use_rate_top5'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'used_percent,vm_mem',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 40,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.disk_use_rate_top5'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'used_percent,vm_disk',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 60,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.net.recv.top5'),
        order: 'TOP',
        resType: 'server',
        time: 1440,
        usage: 'bps_recv,vm_netio',
      },
    }],
  },
  domain: {
    options: [
      { id: 'dashboard-domain-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-domain-default': [{
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 0,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_cpu',
        name: i18n.t('usage.domain.containers'),
        regionAccountType: 'region',
        usage_key: 'domain.containers',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 20,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_tenant',
        name: i18n.t('dashboard.host_total_num'),
        regionAccountType: 'region',
        usage_key: 'domain.hosts',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 40,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_baremetal',
        name: i18n.t('dashboard.running_containers_count'),
        regionAccountType: 'region',
        usage_key: 'domain.running_containers',
      },
    }, {
      layout: {
        component: 'UserInfo',
        h: 6,
        w: 20,
        x: 60,
        y: 0,
      },
      params: {
        name: i18n.t('dashboard.userinfo'),
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 0,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_ram',
        name: i18n.t('dashboard.container_server_cpu_num'),
        regionAccountType: 'region',
        usage_key: 'domain.containers.cpu',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 20,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_baremetal',
        name: i18n.t('dashboard.containers_memory'),
        regionAccountType: 'region',
        unit: 'auto',
        usage_key: 'domain.containers.memory',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 40,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_cpu',
        name: i18n.t('dashboard.running_containers_cpu_num'),
        regionAccountType: 'region',
        unit: 'auto',
        usage_key: 'domain.running_containers.cpu',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 60,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_tenant',
        name: i18n.t('dashboard.running_containers_memory_num'),
        regionAccountType: 'region',
        usage_key: 'domain.running_containers.memory',
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 0,
        y: 12,
      },
      params: {
        all_usage_key: 'domain.servers',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.all.running_servers_rate'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.all.no_running_servers'),
        usage_key: 'domain.running_servers',
        usage_label: i18n.t('dashboard.all.running_servers'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 20,
        y: 12,
      },
      params: {
        all_usage_key: 'domain.disks.count',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_147'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.not_mounted'),
        usage_key: 'domain.disks.mounted.count',
        usage_label: i18n.t('dashboard.mounted'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 40,
        y: 12,
      },
      params: {
        all_usage_key: 'domain.ports',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_152'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.text_34'),
        usage_key: 'domain.nics',
        usage_label: i18n.t('dashboard.text_33'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 60,
        y: 12,
      },
      params: {
        all_usage_key: 'domain.eip.floating_ip',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_156'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.text_34'),
        usage_key: 'domain.eip.floating_ip.used',
        usage_label: i18n.t('dashboard.text_33'),
      },
    }, {
      layout: {
        component: 'Top5',
        h: 10,
        w: 20,
        x: 0,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.text_126'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'usage_active,vm_cpu',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 10,
        w: 20,
        x: 20,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.memory_use_rate_top5'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'used_percent,vm_mem',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 10,
        w: 20,
        x: 40,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.disk_use_rate_top5'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'used_percent,vm_disk',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 60,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.net.recv.top5'),
        order: 'TOP',
        resType: 'server',
        time: 1440,
        usage: 'bps_recv,vm_netio',
      },
    }],
  },
  project: {
    options: [
      { id: 'dashboard-project-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-project-default': [{
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 0,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_cpu',
        name: i18n.t('dashboard.container_server_count'),
        regionAccountType: 'region',
        usage_key: 'containers',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 20,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_tenant',
        name: i18n.t('dashboard.disk_num'),
        regionAccountType: 'region',
        usage_key: 'disks.count',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 40,
        y: 0,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_baremetal',
        name: i18n.t('dashboard.snapshot_num'),
        regionAccountType: 'region',
        usage_key: 'snapshot',
      },
    }, {
      layout: {
        component: 'UserInfo',
        h: 6,
        w: 20,
        x: 60,
        y: 0,
      },
      params: {
        name: i18n.t('dashboard.userinfo'),
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 0,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_ram',
        name: i18n.t('dashboard.container_server_cpu_num'),
        regionAccountType: 'region',
        usage_key: 'containers.cpu',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 20,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_baremetal',
        name: i18n.t('dashboard.containers_memory'),
        regionAccountType: 'region',
        unit: 'auto',
        usage_key: 'containers.memory',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 40,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_cpu',
        name: i18n.t('dashboard.running_containers_cpu_num'),
        regionAccountType: 'region',
        unit: 'auto',
        usage_key: 'running_containers.cpu',
      },
    }, {
      layout: {
        component: 'NumberCard',
        h: 6,
        w: 20,
        x: 60,
        y: 6,
      },
      params: {
        chart_type: 'icon',
        icon: 'icon_tenant',
        name: i18n.t('dashboard.running_containers_memory_num'),
        regionAccountType: 'region',
        usage_key: 'running_containers.memory',
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 0,
        y: 12,
      },
      params: {
        all_usage_key: 'servers',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.all.running_servers_rate'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.all.no_running_servers'),
        usage_key: 'running_servers',
        usage_label: i18n.t('dashboard.all.running_servers'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 20,
        y: 12,
      },
      params: {
        all_usage_key: 'disks.count',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_147'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.not_mounted'),
        usage_key: 'disks.mounted.count',
        usage_label: i18n.t('dashboard.mounted'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 40,
        y: 12,
      },
      params: {
        all_usage_key: 'ports',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_152'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.text_34'),
        usage_key: 'nics',
        usage_label: i18n.t('dashboard.text_33'),
      },
    }, {
      layout: {
        component: 'Ring',
        h: 5,
        w: 20,
        x: 60,
        y: 12,
      },
      params: {
        all_usage_key: 'eip.floating_ip',
        chart_type: 'liquidfill',
        name: i18n.t('dashboard.text_156'),
        regionAccountType: 'region',
        un_usage_label: i18n.t('dashboard.text_34'),
        usage_key: 'eip.floating_ip.used',
        usage_label: i18n.t('dashboard.text_33'),
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 0,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.text_126'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'usage_active,vm_cpu',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 20,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.memory_use_rate_top5'),
        order: 'TOP',
        resType: 'server',
        time: 604800,
        usage: 'used_percent,vm_mem',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 40,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.disk_use_rate_top5'),
        order: 'TOP',
        resType: 'server',
        time: 18000,
        usage: 'used_percent,vm_disk',
      },
    }, {
      layout: {
        component: 'Top5',
        h: 8,
        w: 20,
        x: 60,
        y: 17,
      },
      params: {
        brand: '',
        dimensionId: 'vm_id',
        limit: 5,
        name: i18n.t('dashboard.net.recv.top5'),
        order: 'TOP',
        resType: 'server',
        time: 1440,
        usage: 'bps_recv,vm_netio',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 0,
        y: 25,
      },
      params: {
        all_usage_key: 'cpu',
        name: i18n.t('dashboard.cpu_quota'),
        type: 'project-quota-common',
        usage_key: 'usage.cpu',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 20,
        y: 25,
      },
      params: {
        all_usage_key: 'memory',
        name: i18n.t('dashboard.memory_quota'),
        type: 'project-quota-common',
        usage_key: 'usage.memory',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 40,
        y: 25,
      },
      params: {
        all_usage_key: 'storage',
        name: i18n.t('dashboard.storage_quota'),
        type: 'project-quota-common',
        usage_key: 'usage.storage',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 60,
        y: 25,
      },
      params: {
        all_usage_key: 'eip',
        name: i18n.t('dashboard.eip_quota'),
        type: 'project-quota-region',
        usage_key: 'usage.eip',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 0,
        y: 31,
      },
      params: {
        all_usage_key: 'port',
        name: i18n.t('dashboard.port_quota'),
        type: 'project-quota-region',
        usage_key: 'usage.port',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 20,
        y: 31,
      },
      params: {
        all_usage_key: 'isolated_device',
        name: i18n.t('dashboard.gpu_quota'),
        type: 'project-quota-common',
        usage_key: 'usage.isolated_device',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 40,
        y: 31,
      },
      params: {
        all_usage_key: 'image',
        name: i18n.t('dashboard.image_quota'),
        type: 'project-quota-image',
        usage_key: 'usage.image',
      },
    }, {
      layout: {
        component: 'ProjectQuota',
        h: 6,
        w: 20,
        x: 60,
        y: 31,
      },
      params: {
        all_usage_key: 'snapshot',
        name: i18n.t('dashboard.snapshot_quota'),
        type: 'project-quota-region',
        usage_key: 'usage.snapshot',
      },
    }],
  },
}
